module.exports = __webpack_public_path__ + "static/media/LossSell.4d8e7ec6.svg";